"use strict";
/*!
 *
 *  search.ts
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResult = exports.locationSearch = exports.areaSearch = void 0;
var vue_1 = __importDefault(require("vue"));
var vuejs_paginate_1 = __importDefault(require("vuejs-paginate"));
var areaSearch = /** @class */ (function () {
    function areaSearch() {
        this.pref = [
            ['北海道'],
            ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県'],
            ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県'],
            ['新潟県', '富山県', '石川県', '福井県', '長野県'],
            ['岐阜県', '静岡県', '愛知県', '三重県'],
            ['滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県'],
            ['鳥取県', '島根県', '岡山県', '広島県', '山口県'],
            ['徳島県', '香川県', '愛媛県', '高知県'],
            ['福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
        ];
        if ($('#areaSearch').length) {
            new vue_1.default({
                el: '#areaSearch',
                data: {
                    area: '',
                    pref: '',
                    prefList: this.pref
                },
                methods: {
                    resetPref: function () {
                        this.pref = '';
                    }
                }
            });
        }
        ;
    }
    return areaSearch;
}());
exports.areaSearch = areaSearch;
var locationSearch = /** @class */ (function () {
    function locationSearch() {
        if ($('#locationSearch').length) {
            var self_1 = this;
            new vue_1.default({
                el: '#locationSearch',
                data: {
                    lat: '',
                    lng: '',
                    isError: false
                },
                methods: {
                    setLocation: function (e) {
                        var _this = this;
                        e.preventDefault();
                        console.log('aaa');
                        self_1.getLocation(function (pos) {
                            var crd = pos.coords;
                            _this.lat = crd.latitude.toString();
                            _this.lng = crd.longitude.toString();
                            _this.isError = false;
                            setTimeout(function () {
                                _this.$el.submit();
                            }, 1);
                        }, function () {
                            _this.isError = true;
                        });
                    }
                }
            });
        }
        ;
    }
    locationSearch.prototype.getLocation = function (success, error) {
        var geo = navigator.geolocation;
        if (geo) {
            geo.getCurrentPosition(success, error, {
                enableHighAccuracy: false,
                timeout: 5000,
                maximumAge: 0
            });
        }
        else {
            error;
        }
    };
    return locationSearch;
}());
exports.locationSearch = locationSearch;
var axios_1 = __importDefault(require("axios"));
var searchResult = /** @class */ (function () {
    function searchResult() {
        this.pref = '';
        this.lat = 0;
        this.lng = 0;
        // jsonURL: string = 'https://dev.suresmile-support.jp/shoplist/';
        this.jsonURL = '/search/shoplist.json';
        this.shops = [];
        this.mode = 'all';
        if ($('#result').length) {
            this.params = new URLSearchParams(window.location.search);
            this.pref = this.params.get('pref');
            this.lat = Number(this.params.get('lat'));
            this.lng = Number(this.params.get('lng'));
            this.init();
        }
        ;
    }
    searchResult.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, geocoder, latlng;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.get(this.jsonURL)];
                    case 1:
                        res = _a.sent();
                        this.shops = res.data.filter(function (val) {
                            return val.show;
                        }).map(function (val) {
                            return {
                                lat: Number(val.lat),
                                lng: Number(val.lng),
                                hospitalname: val.hospitalname,
                                zip: val.zip,
                                city: val.city,
                                pref: val.pref,
                                address: val.address,
                                tel: val.tel
                            };
                        });
                        if (this.pref !== null) {
                            this.mode = 'pref';
                        }
                        ;
                        if (this.lat !== 0 && this.lng !== 0) {
                            this.mode = 'current';
                        }
                        ;
                        if (this.mode === 'current') {
                            geocoder = new google.maps.Geocoder();
                            latlng = new google.maps.LatLng(this.lat, this.lng);
                            geocoder.geocode({ 'location': latlng }, function (results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    var num = results[0].address_components.length - 3;
                                    var pref = results[0].address_components[num].long_name;
                                    _this.pref = pref;
                                    _this.build();
                                }
                                else {
                                    _this.mode = 'all';
                                    _this.build();
                                }
                                ;
                            });
                        }
                        else {
                            this.build();
                        }
                        ;
                        return [2 /*return*/];
                }
            });
        });
    };
    searchResult.prototype.build = function () {
        console.log(this.pref);
        var self = this;
        vue_1.default.component('paginate', vuejs_paginate_1.default);
        new vue_1.default({
            el: '#result',
            data: {
                shops: self.shops,
                pref: self.pref,
                lat: self.lat,
                lng: self.lng,
                mode: self.mode,
                inited: false,
                page: 1
            },
            computed: {
                title: function () {
                    if (this.mode === 'all') {
                        return "\u691C\u7D22\u7D50\u679C";
                    }
                    else if (this.mode === 'pref') {
                        return "\u691C\u7D22\u7D50\u679C\uFF1A\u300C".concat(this.pref, "\u300D");
                    }
                    else {
                        return '検索結果：現在地から';
                    }
                },
                activeList: function () {
                    var _this = this;
                    return this.shops.filter(function (val) {
                        return val.pref === _this.pref || _this.pref === null;
                    });
                },
                maxPage: function () {
                    return Math.ceil(this.activeList.length / 15);
                },
                activePageList: function () {
                    var _this = this;
                    return this.activeList.filter(function (item, i) {
                        var start = (_this.page - 1) * 15;
                        var end = start + 15;
                        return start <= i && end > i;
                    });
                }
            },
            mounted: function () {
                this.createMap();
                // console.log(this.activeList.length, this.maxPage);
            },
            methods: {
                changePage: function () {
                    var $table = $(this.$el).find('.sch-table');
                    var top = $table.offset().top;
                    $(util.scroller).animate({
                        scrollTop: top - util.scrollGap
                    }, {
                        duration: 0,
                        queue: false
                    });
                },
                createMap: function () {
                    var _this = this;
                    var lat = this.lat;
                    var lng = this.lng;
                    if (lat === 0 && lng === 0) {
                        this.activeList.forEach(function (shop) {
                            lat += shop.lat;
                            lng += shop.lng;
                        });
                        lat /= this.activeList.length;
                        lng /= this.activeList.length;
                    }
                    ;
                    var map = new google.maps.Map(document.getElementById('map'), {
                        center: {
                            lat: lat,
                            lng: lng
                        },
                        zoom: 10
                    });
                    var markers = [];
                    var infowindows = [];
                    this.shops.forEach(function (item, i) {
                        markers[i] = new google.maps.Marker({
                            position: {
                                lat: item.lat,
                                lng: item.lng
                            },
                            map: map,
                            title: item.hospitalname
                        });
                        infowindows[i] = new google.maps.InfoWindow({
                            content: "\n\t\t\t\t\t\t\t\t<div class=\"sch-infowindow\">\n\t\t\t\t\t\t\t\t\t<div class=\"sch-infowindow__name\">".concat(item.hospitalname, "</div>\n\t\t\t\t\t\t\t\t\t<div class=\"sch-infowindow__address\">\u3012").concat(item.zip, "\u3000").concat(item.pref + item.city + item.address, "</div>\n\t\t\t\t\t\t\t\t\t<div class=\"sch-infowindow__tel\">").concat(item.tel !== '' ? 'TEL：' + item.tel : '', "</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t")
                        });
                        markers[i].addListener('click', function () {
                            infowindows.forEach(function (iw) {
                                iw.close();
                            });
                            infowindows[i].open({
                                anchor: markers[i],
                                map: map,
                                shouldFocus: false
                            });
                        });
                    });
                    google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
                        _this.inited = true;
                    });
                }
            }
        });
    };
    return searchResult;
}());
exports.searchResult = searchResult;
